import { XsrfOptions } from 'src/app/common/interceptors/xsrf.interceptor';
import { LogLevel } from 'src/app/common/util/log';

export const basePath: string = 'https://zfdr.dev.api.union-investment.de/beta/web/ik/rpt/api/v1';
export const assetPath: string = 'https://widgetservice-dev.fe.union-investment.de/export';

export const loglevel: LogLevel = LogLevel.TRACE;

export const fondsportraitTabQueryParamName: string = "fptab";

export const manifestUrls = {
  doka: 'https://dokumentenablage-dev.fe.union-investment.de/scs/iko-doka-dokumentenuebersicht/iko-doka-dokumentenuebersicht.manifest.json',
  fondstableSidepanel: {
    addSubscription: 'https://aboservice-dev.fe.union-investment.de/abo-fixer-fonds-button.json',
    subscribedDocuments: 'https://aboservice-dev.fe.union-investment.de/aboliste-spezifisch.json',
  },
};

export const authInterceptorIgnoredUrls: string[] = [
  manifestUrls.doka
];

export const xsrfInterceptorIgnoredUrls: string[] = [
  manifestUrls.doka
];

export const xsrfOptions: XsrfOptions = {
  cookieName: 'XSRF-TOKEN-FONDSUEBERSICHT',
  headerName: 'X-XSRF-TOKEN-FONDSUEBERSICHT',
};

export const apimApiVersion: string = 'beta-1.0.0';

export const logging = {
  connectionString:
    'InstrumentationKey=c239a6ab-bd01-466b-881a-d91745512ade;IngestionEndpoint=https://westeurope-4.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=f7ee889c-3719-4d8a-8c32-ad80801aa288',
};
